module.exports = __webpack_public_path__ + "static/sunset-glasses-43874586ac793ea3a0f2e1eb92d1bd71.jpg";